var React = require('react');

function Twitter (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#00A3FF","d":"M31.524 6.583c-1.114.493-2.31.826-3.567.977a6.227 6.227 0 002.73-3.437 12.4 12.4 0 01-3.943 1.506 6.213 6.213 0 00-10.584 5.667 17.638 17.638 0 01-12.803-6.49 6.208 6.208 0 00-.84 3.122 6.214 6.214 0 002.763 5.17 6.197 6.197 0 01-2.814-.777v.08a6.213 6.213 0 004.983 6.091 6.257 6.257 0 01-2.805.107 6.215 6.215 0 005.802 4.312 12.464 12.464 0 01-7.714 2.66c-.496 0-.99-.03-1.483-.087a17.566 17.566 0 009.52 2.79c11.427 0 17.673-9.463 17.673-17.671 0-.267-.006-.536-.018-.803a12.627 12.627 0 003.097-3.213l.003-.004z"}));
}

Twitter.defaultProps = {"fill":"none","viewBox":"0 0 32 32"};

module.exports = Twitter;

Twitter.default = Twitter;
